import { quizz } from '@/data/quizz'
import { QuizzMedal, QuizzType, QuizzUserAnswer } from '@/types/Quizz'
import { defineStore } from 'pinia'

interface QuizzState {
  userAnswers: QuizzUserAnswer[]
  currentMedal: QuizzMedal
  patternIndex: number
}

export const useStoreQuizz = defineStore('quizzStore', {
  state: (): QuizzState => {
    return {
      userAnswers: [],
      currentMedal: QuizzMedal.NONE,
      patternIndex: -1,
    }
  },

  actions: {
    init() {
      this.retrieveLocalStorage()

      // Random pattern
      this.selectRandomPattern()
    },

    retrieveLocalStorage() {
      const userAnswers = localStorage.getItem('quizzUserAnswers')
      const currentMedal = localStorage.getItem('quizzCurrentMedal')
      const patternIndex = localStorage.getItem('quizzPatternIndex')

      if (userAnswers) {
        this.userAnswers = JSON.parse(userAnswers) as QuizzUserAnswer[]
      }

      if (currentMedal) {
        this.currentMedal = currentMedal as QuizzMedal
      }

      if (patternIndex) {
        this.patternIndex = parseInt(patternIndex)
      }
    },

    selectRandomPattern(forceNew = false) {
      if (this.patternIndex === -1 || forceNew) {
        this.patternIndex = Math.floor(Math.random() * 3)
        console.log(`Selecting pattern ${this.patternIndex}`)

        localStorage.setItem('quizzPatternIndex', this.patternIndex.toString())
      }
    },

    update(sentenceId: number, answersId: number[]) {
      this.saveUserAnswers(sentenceId, answersId)

      const score = this.getScore()

      this.updateCurrentMedal(score)
    },

    saveUserAnswers(sentenceId: number, answersId: number[]) {
      this.userAnswers.push({
        sentenceId,
        answersId,
      })

      localStorage.setItem('quizzUserAnswers', JSON.stringify(this.userAnswers))
    },
    getScore() {
      const currentQuizz = quizz[this.patternIndex]

      let nbrWrongAnswers = 0
      let score = 0

      this.userAnswers.forEach((userAnswer) => {
        const quizz = currentQuizz.find(
          (sentence) => sentence.id === userAnswer.sentenceId
        )

        const correctAnswers = quizz?.correctAnswers

        if (correctAnswers) {
          if (quizz?.type === QuizzType.QCM) {
            correctAnswers.forEach((correctAnswer) => {
              if (!userAnswer.answersId.includes(correctAnswer)) {
                nbrWrongAnswers++
              }
            })

            userAnswer.answersId.forEach((userAnswerId) => {
              if (!correctAnswers.includes(userAnswerId)) {
                nbrWrongAnswers++
              }
            })
          } else if (quizz?.type === QuizzType.ILLUSTRATION) {
            correctAnswers.forEach((correctAnswer, index) => {
              if (correctAnswer !== userAnswer.answersId[index]) {
                nbrWrongAnswers++
              }
            })
          }

          if (nbrWrongAnswers === 0) {
            score++
          }

          nbrWrongAnswers = 0
        }
      })

      return score
    },
    updateCurrentMedal(score: number) {
      let medal = this.currentMedal

      switch (score) {
        case 0:
          medal = QuizzMedal.NONE
          break
        case 1 || 2:
          medal = QuizzMedal.BRONZE
          break
        case 3 || 4:
          medal = QuizzMedal.SILVER
          break
        case 5:
          medal = QuizzMedal.GOLD
      }

      if (medal !== this.currentMedal) {
        this.currentMedal = medal
        localStorage.setItem('quizzCurrentMedal', medal)
      }
    },
    reset() {
      localStorage.removeItem('quizzUserAnswers')
      localStorage.removeItem('quizzCurrentMedal')
      localStorage.removeItem('quizzPatternIndex')

      this.userAnswers = []
      this.currentMedal = QuizzMedal.NONE
      this.patternIndex = Math.floor(Math.random() * 3)
    },
  },
})
